// Grille des 13 semaines d'une saison (R-TDB-04, R-PLA-05). Couleurs neutres, jamais d'alerte (R-GEN-01).
import type { SemaineRegularite } from '@partage/programme';

export function GrilleRegularite({ grille, auClic }: { grille: SemaineRegularite[]; auClic?: (s: SemaineRegularite) => void }) {
  if (!grille.length) return <p className="vide">Active la saison pour voir la grille.</p>;
  return (
    <div className="regularite" role="list">
      {grille.map((s) => (
        <div key={s.semaine} role="listitem" className={`semaine ${s.statut}`} title={`Semaine ${s.numero} (${s.semaine}) : ${s.sessions} session${s.sessions > 1 ? 's' : ''}${s.defi ? ', défi fait' : ''}${s.statut === 'off' ? ', off' : ''}`} onClick={auClic ? () => auClic(s) : undefined} style={auClic ? { cursor: 'pointer' } : undefined}>
          {s.numero}
          {s.defi ? <span className="etoile" aria-label="défi fait">★</span> : null}
        </div>
      ))}
    </div>
  );
}
